var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMechanical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "#FFB800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.66663 25.0411C6.66663 22.4212 7.21617 19.9297 8.20626 17.6755L16.7013 26.1705C19.3048 28.774 23.5259 28.774 26.1294 26.1705C28.7329 23.567 28.7329 19.3459 26.1294 16.7425L17.6344 8.24739C19.8886 7.2573 22.3801 6.70776 25 6.70776C35.1252 6.70776 43.3333 14.9159 43.3333 25.0411C43.3333 27.661 42.7838 30.1525 41.7937 32.4067L74.7499 65.3629C75.5309 66.144 75.5309 67.4103 74.7499 68.1914L68.1502 74.791C67.3692 75.5721 66.1029 75.5721 65.3218 74.791L32.3656 41.8348C30.1114 42.8249 27.6198 43.3744 25 43.3744C14.8747 43.3744 6.66663 35.1663 6.66663 25.0411Z",
    stroke: "#FFB800",
    strokeWidth: 1,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMechanical);
export default __webpack_public_path__ + "static/media/mechanical.19b9936381ee881fdd40c1271058e280.svg";
export { ForwardRef as ReactComponent };